import { MetricsTableHeadCell } from './metrics-table-head-cell';

export { MetricsTableHeadCell };
